module.exports = __webpack_public_path__ + "7ade8262c616a6643379257f342d0fd7.svg";